import React from 'react'
import { Icon, message, Upload } from 'antd'

import { streamUrl } from '../../../variables/index'
import Authentication from '../../../modules/Authentication'
import Members from '../../../api/Members'
import moment from 'moment'

function getBase64 (img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

function beforeUpload (file) {
  const isJPG = file.type.includes('image')
  if (!isJPG) {
    message.error('You can only upload JPG file!')
  }
  const isLt2M = file.size / 1024 / 1024 < 2
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!')
  }
  return isJPG && isLt2M
}

class Avatar extends React.Component {
  state = {}
  auth = new Authentication()
  api = new Members()
  handleChange = async (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ fetching: true })
    }
    if (info.file.status === 'done') {
      await this.api.update(Object.assign({}, { _key: this.props.id }, { image: info.file.response[0]._key }))
      this.setState({ fetching: false })
      getBase64(info.file.originFileObj, (imageUrl) => this.setState({ imageUrl }))
      if (this.props.handleUpdated) this.props.handleUpdated()
    }
  }

  async componentDidMount () {
    try {
      this.setState({ fetching: true })
      let response = await this.api.getImage(this.props.id)
      let file = await response.json()
      try {
        await this.api.checkImage(file._key)
        this.setState({
          imageUrl: `${streamUrl}files/${file._key}?action=view&access_token=${this.auth.getAccessToken()}`,
          fetching: false,
        })
      } catch (error) {
        this.setState({
          imageUrl: ``,
          fetching: false,
        })
      }
    } catch (err) {
      this.setState({ fetching: false })
      // message.error(err.errorMessage)
    }
  }

  render () {
    const imageUrl = this.state.imageUrl
    const { id } = this.props
    const uploadButton = (
      <div>
        <Icon type={this.state.fetching ? 'loading' : 'plus'}/>
        <div className="ant-upload-text">Upload</div>
      </div>
    )
    return (
      <Upload
        className="avatar-uploader"
        name="upload"
        listType="picture-card"
        showUploadList={false}
        action={`${streamUrl}files/`}
        data={{
          meta: JSON.stringify({
            folder: `members/${id}`,
            timestamp: moment(),
            category: 'profile',
          }),
        }}
        beforeUpload={beforeUpload}
        onChange={this.handleChange}
        headers={{ authorization: `Bearer ${this.auth.getAccessToken()}` }}>
        {imageUrl ? <img src={imageUrl} alt="" className="avatar"/> : uploadButton}
      </Upload>
    )
  }
}

export default Avatar
